import { States } from "@/firebase/index";

export default {
  getAllStates() {
    return States.get();
  }
};
